import { ThemeConfig } from '@sinohealth/butterfly-ui-antd/lib/config-provider';
import { theme } from '@sinohealth/butterfly-ui-components';

interface LightTheme extends ThemeConfig {}

// 亮色主题配置
export const lightTheme: LightTheme = {
  token: {
    // fontSize: 18,
    colorPrimary: '#0365bf', // 主色
    colorInfo: '#227fcc', // 信息色
    colorWarning: '#F2B84C', // 警告色
    colorError: '#EB5757', // 错误色
    colorSuccess: '#27AE60', // 成功色
    colorBgBase: '#FFFFFF', // 基础背景色
    colorBorder: '#E5E8EC', // 边框颜色
    colorText: '#0F2F4F', // 一级文本色
    colorTextSecondary: '#204568', // 次要文本颜色
    colorTextTertiary: '#4f6e91', // 三级文本颜色
    colorTextQuaternary: '#7994ad', // 四级文本颜色
    colorBgContainer: '#fff', // 组件容器背景色
    colorFill: '#DADFE5', // 一级填充色
    colorFillSecondary: '#E5E8EC', // 二级填充色
    colorFillTertiary: '#EFF2F5', // 三级填充色
    // colorFillQuaternary: '#F4F6F8', // 四级填充色
    colorLink: '#0365bf', // 链接颜色
    colorLinkHover: '#0365bf', // 链接悬浮颜色
    colorLinkActive: '#0365bf', // 链接激活颜色
    colorBgLayout: '#F4F6F8', // 布局背景色
    // colorBgElevated: '#FFFFFF', // 浮层容器背景色
    // colorBgSpotlight: '#F4F6F8', // 引起注意的背景色
  },
  components: {
    Menu: {
      colorGroupTitle: '',
      colorItemText: '#4F6E91',
      colorItemTextHover: '#4F6E91',
      colorItemTextHoverHorizontal: '#4F6E91',
      colorItemTextSelected: '#204568',
      colorItemTextSelectedHorizontal: '#204568',
      colorItemBgHover: '#E6F2FB',
      // colorItemBgActive: 'string',
      // colorItemBgSelected: 'string',
      // colorItemBgSelectedHorizontal: 'string',
    },
    Table: {
      // colorBgContainer: '#fff',
      colorBorderSecondary: '#E5E8EC',
      colorTextHeading: '#0F2F4F',
      colorFillAlter: '#F4F6F8',
      colorFillContent: '#F4F6F8',
      colorFillSecondary: '#7994AD',
      colorFillTertiary: '#204568',
    },
    Segmented: {
      colorPrimary: '#0365bf',
    },
  },
  algorithm: theme.defaultAlgorithm,
};

// 暗色主题配置
export const darkTheme: ThemeConfig = {
  token: {
    colorPrimary: '#227fcc', // 主色
    colorInfo: '#227fcc', // 信息色
    colorWarning: '#f5cb72', // 警告色
    colorError: '#ef807c', // 错误色
    colorErrorBg: '#4d1413', // 错误背景色
    colorErrorBgHover: '#5d1817', // 错误背景色悬浮
    colorErrorBorder: '#8d2423', // 错误边框颜色
    colorErrorBorderHover: '#9d2827', // 错误边框颜色悬浮
    colorErrorHover: '#ef807c', // 错误悬浮颜色
    colorSuccess: '#51be7a', // 成功色
    colorBgBase: '#232324', // 基础背景色
    colorBgContainer: '#313132', // 容器背景色
    colorBgLayout: '#17171a', // 布局背景色
    colorBgElevated: '#17171a', // 悬浮背景色
    colorBgSpotlight: '#17171a', // 焦点背景色
    colorBgMask: 'rgba(0, 0, 0, 0.45)', // 遮罩背景色
    colorBgTextHover: '#fff', // 悬浮文本颜色
    colorBgTextActive: '#fff', // 激活文本颜色
    colorText: '#fff', // 一级文本色
    colorTextBase: '#fff', // 基础文本颜色
    colorTextSecondary: '#fff', // 次要文本颜色
    colorTextTertiary: '#fff', // 三级文本颜色
    colorTextQuaternary: '#fff', // 四级文本颜色
    colorTextDisabled: '#fff', // 禁用文本颜色
    colorLink: '#fff', // 链接文本颜色
    colorBorder: '#2c2c2e', // 边框颜色
    colorBorderSecondary: '#3a3a3c', // 次要边框颜色
    colorFill: '#2c2c2e', // 填充颜色
    colorFillSecondary: '#3a3a3c', // 次要填充颜色
    colorFillTertiary: '#4d4d4f', // 三级填充颜色
    colorFillQuaternary: '#6e6e70', // 四级填充颜色
    colorLinkHover: '#fff', // 链接悬浮颜色
    colorLinkActive: '#fff', // 链接激活颜色
  },
  algorithm: theme.darkAlgorithm,
};

export default lightTheme;
